import { IObservable, Subject } from '~/rage/utils';
import { IJobFarmerService } from './jobFarmerServiceTypes';

export class JobFarmerServiceStub implements IJobFarmerService {
	public getGameTime(): IObservable<number> {
		return new Subject<number>(20000);
	}

	public async reportWin(): Promise<void> {
		console.log('GameFruitsService: reportWin');
	}

	public async reportLoss(): Promise<void> {
		console.log('GameFruitsService: reportLoss');
	}
}
